// vendors
import { EditorState, ContentState, convertToRaw } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import store from "../../../Store/index";
import { whatsappDecodeHTMLEntities } from "../../../Utils";
const getInitialEditorText = (text: string) => {
  const currentBot = store.getState();
  const whatsappText = currentBot?.userData?.dashboardData?.currentBot?.channel === "whatsapp" ? convertWhatsappToHtmlText(text || "") : text;
  if (
    currentBot?.userData?.dashboardData?.currentBot?.channel === "whatsapp" ||
    currentBot?.userData?.dashboardData?.currentBot?.channel === "messenger" ||
    currentBot?.userData?.dashboardData?.currentBot?.channel === "telegram"
  ) {
    text = getHtmlTextChannelWise(whatsappText);
  }
  const contentBlock = htmlToDraft(whatsappText);
  let initialEditorState = EditorState.createEmpty();
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
    );
    const editorState = EditorState.createWithContent(contentState);
    initialEditorState = editorState;
  }
  return initialEditorState;
};

const getPlainTextData = (editorState: EditorState) => {
  if (!editorState) return "";
  const blocks = convertToRaw(editorState.getCurrentContent()).blocks;
  // Join all block text directly to preserve spaces and get accurate character count
  const plainText = blocks
    .map((block) => block.text)
    .join("\n");
  
  return plainText;
};

const getHTMLContent = (editorState: EditorState) => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

const hasIgnoredClass = (element: any, ignoredClass: any) =>
  (element.correspondingElement
    ? element.correspondingElement
    : element
  ).classList.contains(ignoredClass);

const isInIgnoredElement = (element: any, ignoredClass: any) => {
  do {
    if (
      hasIgnoredClass(element, ignoredClass) ||
      hasIgnoredClass(element, "MuiPopover-root") ||
      hasIgnoredClass(element, "MuiPickersPopper-root") || 
      hasIgnoredClass(element, "MuiPickersPopper-root") ||
      hasIgnoredClass(element, "MuiDialog-root") ||
      hasIgnoredClass(element, "MuiModal-root")
    ) {
      return true;
    }
  } while ((element = element.parentElement));

  return false;
};

const getMediaDetails = (response: any) => {
  let mediaDetails: any = {};
  if (response && response !== null && response.length > 0) {
    const match = response.filter((item: any) => item.type === "text");
    mediaDetails = match.length === 1 ? match?.[0]?.media : "";
  }
  return mediaDetails;
};
const getMediaDetailsForMediaNode = (response: any) => {
  let mediaDetails: any= {};  
  if (response?.[0]?.value) {
    mediaDetails = response[0]
  }
  return mediaDetails;
};

const getLocationDetails = (response: any) => {
  let locationDetails = {};
  if (response?.[0]?.value) {
    locationDetails = response[0]
  }
  return locationDetails;
}

const getLocationDetailsLocationNode = (response: any) => {
  let locationDetails = {};
  if(response?.[0]?.value && response?.[0]?.value?.latitude){
    locationDetails = response[0]
  }
  return locationDetails;
}

const clean = (object: any) => {
  if (object) {
    Object.keys(object).forEach(function (key) {
      if (object[key].url === "") {
        delete object[key];
      }
    });
    return object;
  }
};

const cleanMediaDetails = (mediaDetails: any) => {
  return clean(mediaDetails);
};

const htmlStringToLink = (htmlString: string) => {
  // Regular expression to match URLs
  const regex = /(https?:\/\/[^<>\s]+)/g;
  const parts = htmlString?.split(regex);

  if (!parts) return htmlString;

  return parts
    ?.map((part: any, index: number) => {
      if (part?.match(regex)) {
        return `<a href="${part}" target="_blank" rel="noopener noreferrer">${part}</a>`;
      }
      return part;
    })
    .join("");
};

export const getTextWithoutHtml = (string: string) => {
  let strippedHtml = string?.replace(/<[^>]+>/g, "");
  return strippedHtml;
};

export const checkEmptyString = (htmlText: string): string => {
  if (!htmlText) return "";

  const comparisonString1 = "<p></p>\n";
  const comparisonString2 = "<p></p>";

  if (htmlText === comparisonString1 || htmlText === comparisonString2) {
    return "";
  }

  return htmlText;
};
export const replaceEmptyPTagsWithBr = (htmlText: string) => {
  htmlText = checkEmptyString(htmlText);

  if (!htmlText) return "";

   // Replace &amp; with &
   htmlText = htmlText.replace(/&amp;/g, "&");

  let withoutEmptyPTags = htmlText?.replace(/<p><\/p>/g, "<br/>").replace(/&amp;/g, "&");
  return withoutEmptyPTags;
};
export const convertHtmlToWhatsappText = (text: string) => {
  if (!text) return "";
  let strBold = text;
  let replacedBold = strBold
    ?.replace(/<strong>/g, "*")
    ?.replace(/<\/strong>/g, "*");
  let strItalic = replacedBold;
  let replacedItalic = strItalic
    ?.replace(/<em>/g, "_")
    ?.replace(/<\/em>/g, "_");

  let strStrike = replacedItalic;
  let replacedStrike = strStrike
    ?.replace(/<del>/g, "~")
    ?.replace(/<\/del>/g, "~");

  let strMono = replacedStrike;
  let replacedMono = strMono
    ?.replace(/<tt>/g, "```")
    ?.replace(/<\/tt>/g, "```")
    ?.replace(/<code>/g, "```")
    ?.replace(/<\/code>/g, "```");
  
    // Decode HTML entities first 
  replacedMono = whatsappDecodeHTMLEntities(replacedMono);

  // Convert <br> tags to newline characters before stripping tags so line breaks are preserved
  replacedMono = replacedMono?.replace(/<br\s*\/?>(?=)/gi, "\n");

  // Handle lists (ordered & unordered) -> each <li> becomes a new line with '- '
  // First, handle ordered lists separately to keep numbering
  replacedMono = replacedMono?.replace(/<ol[^>]*>([\s\S]*?)<\/ol>/gi, (_full: string, inner: string) => {
    const items = inner.match(/<li[^>]*>([\s\S]*?)<\/li>/gi);
    if (!items) return "";
    let idx = 1;
    const lines = items.map((li) => {
      const content = li.replace(/<\/?li[^>]*>/gi, "") // remove <li> wrappers
        .replace(/<[^>]+>/g, "") // strip any nested tags left
        .trim();
      if (!content) return "";
      return `${idx++}. ${content}`;
    }).filter(Boolean);
    return (lines.length ? "\n" + lines.join("\n") : "");
  });
  // Rebuild unordered lists similarly (avoid leftover whitespace lines)
  replacedMono = replacedMono?.replace(/<ul[^>]*>([\s\S]*?)<\/ul>/gi, (_full: string, inner: string) => {
    const items = inner.match(/<li[^>]*>([\s\S]*?)<\/li>/gi);
    if (!items) return "";
    const lines = items.map((li) => {
      const content = li.replace(/<\/?li[^>]*>/gi, "")
        .replace(/<[^>]+>/g, "")
        .trim();
      if (!content) return "";
      return `- ${content}`;
    }).filter(Boolean);
    return (lines.length ? "\n" + lines.join("\n") : "");
  });

  // Preserve paragraph / block boundaries by inserting newlines for block-level elements before stripping tags
  replacedMono = replacedMono
    // Closing block tags to newline (avoid duplicating if newline already there)
    ?.replace(/<\/(p|div|h[1-6])>\s*/gi, "\n")
    // Opening block tags removed
    ?.replace(/<(p|div|h[1-6])[^>]*>/gi, "");

  // Convert any explicit empty paragraph markers (<p></p>) that slipped through into blank lines
  replacedMono = replacedMono?.replace(/\n?\s*<p>\s*<\/p>\s*\n?/gi, "\n\n");

  let whatsappText: string = getTextWithoutHtml(replacedMono || "")
    .replace(/&nbsp;/g, "")
    .replace(/^\n+/, ""); // trim leading newlines from list conversion

  // (Preserve user-entered blank lines; no collapsing applied)
  // Trim trailing whitespace on each line
  whatsappText = whatsappText.replace(/[\t ]+\n/g, "\n");
  // Remove leading indentation before bullets / numbered items (HTML pretty-print indentation)
  whatsappText = whatsappText.replace(/^[\t ]+(- |\d+\. )/gm, '$1');
  // Generic safeguard: ensure any bullet (- ) or numbered list (\d+. ) starts on a new line
  // This avoids relying on a specific preceding character like a colon.
  // Safer implementation to avoid splitting multi-digit numbers (e.g., '10.' becoming '1\n0.')
  whatsappText = (() => {
    const markerRegex = /(- |\d+\. )/g;
    let out = '';
    let lastIndex = 0;
    let m: RegExpExecArray | null;
    while ((m = markerRegex.exec(whatsappText)) !== null) {
      const marker = m[0];
      const idx = m.index;
      out += whatsappText.slice(lastIndex, idx);
      const prevChar = idx > 0 ? whatsappText[idx - 1] : '';
      const isNumberMarker = /^(\d+)\. $/.test(marker);
      if (idx === 0 || prevChar === '\n' || (isNumberMarker && /\d/.test(prevChar))) {
        out += marker;
      } else {
        out += '\n' + marker;
      }
      lastIndex = idx + marker.length;
    }
    out += whatsappText.slice(lastIndex);
    return out;
  })();
  // Repair any previously split multi-digit ordered list numbers (handles optional blank lines):
  // Sequence like: '1' '\n' '0. Item' -> '10. Item'; also '1' '\n' '2' '\n' '3. Item' -> '123. Item'
  whatsappText = (() => {
    const lines = whatsappText.split(/\n/);
    const repaired: string[] = [];
    for (let i = 0; i < lines.length; i++) {
      const cur = lines[i];
      if (/^\d$/.test(cur.trim())) {
        let digitBuffer = cur.trim();
        let j = i + 1;
        while (j < lines.length) {
          const probe = lines[j].trim();
          if (probe === '') { j++; continue; }
          if (/^\d$/.test(probe)) { digitBuffer += probe; j++; continue; }
          const finalMatch = /^(\d)\.\s+(.*)$/.exec(probe);
          if (finalMatch) {
            const fullNumber = digitBuffer + finalMatch[1];
            repaired.push(fullNumber + '. ' + finalMatch[2]);
            i = j; // advance outer loop to consumed line
            break;
          }
          // Not a continuation; push first digit line and process normally
          repaired.push(cur);
          break;
        }
        if (j >= lines.length) {
          if (repaired[repaired.length - 1] !== cur) repaired.push(cur);
        }
        continue;
      }
      repaired.push(cur);
    }
    return repaired.join('\n');
  })();
  return whatsappText;
};
export const convertHtmlToPlainText = (html: string) => {
  if (!html) return "";

  let plainText = html;

  // Remove bold formatting *text*
  plainText = plainText.replace(/\*(.*?)\*/g, "$1");

  // Remove italic formatting _text_
  plainText = plainText.replace(/_(.*?)_/g, "$1");

  // Remove strikethrough formatting ~text~
  plainText = plainText.replace(/~(.*?)~/g, "$1");

  // Remove monospaced (code) formatting ```text```
  plainText = plainText.replace(/```(.*?)```/g, "$1");

  // Handle line breaks (convert \n to a single space or remove it)
  plainText = plainText.replace(/\n/g, " ");

  // Remove multiple spaces with a single space
  plainText = plainText.replace(/\s\s+/g, " ").trim();

  return plainText;
};
export const getChannelWiseText = (text: string, type?: any,number?:any) => {
  let finalText = text;
  if (!finalText) return "";

  if (type === "whatsapp" || type === "messenger" || type === "telegram") {
    finalText = convertHtmlToWhatsappText(finalText);
    return finalText;
  }

  finalText = finalText?.length > 0 ? replaceEmptyPTagsWithBr(finalText) : "";

  return finalText;
};

const getHtmlTextChannelWise = (text: string, type?: string) => {
  let finalText = text;
  if (!finalText) return "";

  if (type === "whatsapp") {
    finalText = convertWhatsappToHtmlText(text);
    return finalText;
  }

  return finalText;
};

const convertWhatsappToHtmlText = (text: string) => {
  if (!text) return "";
  let raw = text.toString();

  // Recombine any split ordered list numbers in raw prior to list grouping (robust, handles blank lines)
  raw = (() => {
    const lines = raw.split(/\n/);
    const repaired: string[] = [];
    for (let i = 0; i < lines.length; i++) {
      const cur = lines[i];
      if (/^\d$/.test(cur.trim())) {
        let digitBuffer = cur.trim();
        let j = i + 1;
        while (j < lines.length) {
          const probe = lines[j].trim();
          if (probe === '') { j++; continue; }
          if (/^\d$/.test(probe)) { digitBuffer += probe; j++; continue; }
          const finalMatch = /^(\d)\.\s+(.*)$/.exec(probe);
          if (finalMatch) {
            const fullNumber = digitBuffer + finalMatch[1];
            repaired.push(fullNumber + '. ' + finalMatch[2]);
            i = j; break;
          }
          repaired.push(cur); break;
        }
        if (j >= lines.length) {
          if (repaired[repaired.length - 1] !== cur) repaired.push(cur);
        }
        continue;
      }
      repaired.push(cur);
    }
    return repaired.join('\n');
  })();

  // If already contains HTML structure, skip reconversion
  if (/<(ul|ol|li|p)\b/i.test(raw)) {
    return raw;
  }

  const lines = raw.split(/\n/);
  const rebuilt: string[] = [];

  const flushParagraph = (content: string) => {
    if (content === "") { rebuilt.push('<p></p>'); return; }
    rebuilt.push(`<p>${content}</p>`);
  };

  const isBullet = (l: string) => /^(?:-|\u2022)\s*(\S.*)$/.exec(l.trim());
  const isOrdered = (l: string) => /^(\d+)[\.)]\s*(\S.*)$/.exec(l.trim());

  for (let i = 0; i < lines.length; i++) {
    const original = lines[i];
    const trimmed = original.trim();
    if (trimmed === "") { flushParagraph(""); continue; }

    // Group consecutive bullet lines (including a single item so one-line lists still render as bullets)
    const bulletGroup: string[] = [];
    let j = i;
    while (j < lines.length) {
      const m = isBullet(lines[j]);
      if (!m) break;
      bulletGroup.push(m[1].trim());
      j++;
    }
    if (bulletGroup.length >= 1) {
      rebuilt.push('<ul>');
      bulletGroup.forEach(item => rebuilt.push(`<li>${item}</li>`));
      rebuilt.push('</ul>');
      i = j - 1; // advance
      continue;
    }

    // Group consecutive ordered lines (need at least 2)
    const orderedGroup: string[] = [];
    j = i;
    while (j < lines.length) {
      const m = isOrdered(lines[j]);
      if (!m) break;
      orderedGroup.push(m[2].trim());
      j++;
    }
    if (orderedGroup.length >= 2) {
      rebuilt.push('<ol>');
      orderedGroup.forEach(item => rebuilt.push(`<li>${item}</li>`));
      rebuilt.push('</ol>');
      i = j - 1;
      continue;
    }

    // Single line fallbacks
    const singleBullet = isBullet(original);
    if (singleBullet) {
      // Treat a solitary leading dash line as a paragraph with dash preserved
      flushParagraph(`- ${singleBullet[1].trim()}`);
      continue;
    }
    const singleOrdered = isOrdered(original);
    if (singleOrdered) {
      flushParagraph(`${singleOrdered[1]}. ${singleOrdered[2].trim()}`);
      continue;
    }
    flushParagraph(trimmed);
  }

  let htmlText = rebuilt.join("");
  htmlText = htmlText.replace(/&amp;/g, "&");
  const htmlFormat = [
    { symbol: "*", tag: "strong" },
    { symbol: "_", tag: "em" },
    { symbol: "~", tag: "del" },
    { symbol: "`", tag: "code" },
  ];
  htmlFormat.forEach(({ symbol, tag }) => {
    // Match *text* (no line breaks, non-greedy), allow any preceding char except another symbol to avoid spanning across tags
    const regex = new RegExp(`\\${symbol}([^\\n${symbol}][^${symbol}\\n]*)\\${symbol}`, 'g');
    htmlText = htmlText.replace(regex, (_m, inner) => `<${tag}>${inner}</${tag}>`);
  });
  // return `<p>${htmlText}</p>`;
  return `${htmlText}`;
};
const getProcessedLength = (input: string) => {
  // Remove all `{{ ... }}` including content inside and return the remaining string length
  return input?.replace(/\{\{.*?\}\}/g, "").length || 0;
};
const isApiVariable=(value: string) => {
  return /^\{\{.*\}\}$/.test(value);
}

export {
  getInitialEditorText,
  getPlainTextData,
  isInIgnoredElement,
  getHTMLContent,
  getMediaDetails,
  cleanMediaDetails,
  convertWhatsappToHtmlText,
  getHtmlTextChannelWise,
  getProcessedLength,
  isApiVariable,
  getMediaDetailsForMediaNode,
  getLocationDetails,
  getLocationDetailsLocationNode
};
